export default __webpack_public_path__ + "static/media/portfolio-cia-4.58b72604.jpg";